<template>
	<div class='imgEventDom' ref="imgEventDom">
		<div class="box">
			<div class="top_box">
				<div class="title-top">
					<img src="../../../../static/imgV2/breathe.gif" alt="">
					<div class="title-top-text">{{ languageJson.EventDetails }}</div>
				</div>
			</div>

			<div class="eventAuto">
				<div style="width: 99%;display: flex;align-items: center;justify-content: space-around;position: relative;">
					<div class="showRobotClass" v-if="ifZoom"
						:style="{zoom: newRobotInfo.imgList.length == 1 ? zoomNo : zoomNo*2, display: 'inline',width: '98%'}">
						<div class="showRotList showRotListOne" ref="showRotListRef">
							<img :src="checkInfo.imgUrl">
							<div class="errDiv" v-if="checkInfo.position" v-for="(obj, index) in checkInfo.position.split(';')"
								:style="{width: (Number(obj.split(',')[2])-Number(obj.split(',')[0]))-3 + 'px',height: (Number(obj.split(',')[3])-Number(obj.split(',')[1]))-3 + 'px',top: Number(obj.split(',')[1]) + 'px',left: Number(obj.split(',')[0]) + 'px'}">
							</div>
						</div>
					</div>
					<div v-else class="showRobotClass" :style="{borderRadius: '10px', width: '98%',height: '25vw'}">
						<div class="showRotList showRotListOne" ref="showRotListRef">
							<img :src="checkInfo.imgUrl">
						</div>
					</div>
					<img v-if="newRobotInfo.imgList.length > 1 && !show2" class="openImages" src="../../../../static/imgV2/openImages.png" @mouseenter="show2 = true" alt="">
					<transition name="el-zoom-in-center">
						<div v-show="show2" class="transition-box imagesList" @mouseleave="show2 = false">
							<div v-for="(obj,index) in newRobotInfo.imgList" :key="index" :style="{ border: (checkIndex == index) ? '2px solid #4F9FDD' : '2px solid rgba(0, 0, 0, 0)',margin: '0.5vw'}">
								<img :src="obj.imgUrl" @click="checkIndex=index;checkInfo = newRobotInfo.imgList[index]" :class=" index == checkIndex ? 'img_li' : 'img_li check_li' ">
							</div>
						</div>
					</transition>
				</div>

				<div class="eventInfo">
					<div class="eventInfo-title">{{ languageJson.EventInformation }} <span v-if="!robotInfo.isAddMisIdentification && robotInfo.misIdentificationType == '1'" style="color: #FF6A6A;cursor: pointer;" @click="changeWrong()">{{ languageJson.IncorrectIdentification }}</span></div>
					<div class="eventInfo-table">
						<div class="table-div">{{ languageJson.eventType }}</div>
						<div class="table-div">{{ languageJson.ReportingTime }}</div>
						<div class="table-div">{{ languageJson.robotName }}</div>
						<div class="table-div">{{ languageJson.Status }}</div>
						<div class="table-div" v-if="robotInfo.updDate">{{ languageJson.processingTime }}</div>
						<div class="table-div" v-if="robotInfo.handleName">{{ languageJson.ProcessedBy }}</div>
						<div class="table-div" v-if="robotInfo.positionName">{{ languageJson.clockInName }}</div>
						<div class="table-div" v-if="robotInfo.operationType == '8' && robotInfo.pm2_5">{{ languageJson.PM25 }} μg/m³</div>
						<div class="table-div" v-if="robotInfo.operationType == '14'">{{ languageJson.ExtinguishersNumber }}</div>
					</div>

					<div class="eventInfo-table tbody">
						<div class="table-div">{{ robotInfo.eName }}</div>
						<div class="table-div">{{ robotInfo.insDate }}</div>
						<div class="table-div" @click="toRobotLink()"><el-button type="primary" size="mini">{{ robotInfo.rName }}</el-button></div>
						<div class="table-div">{{ robotInfo.resultsName }}</div>
						<div class="table-div" v-if="robotInfo.updDate">{{ robotInfo.updDate }}</div>
						<div class="table-div" v-if="robotInfo.handleName">{{ robotInfo.handleName}}</div>
						<div class="table-div" v-if="robotInfo.positionName">{{ robotInfo.positionName }}</div>
						<div class="table-div" v-if="robotInfo.operationType == '8' && robotInfo.pm2_5">{{ robotInfo.pm2_5 }}</div>
						<div class="table-div" v-if="robotInfo.operationType == '14'">{{ robotInfo.fireExtinguisherResultNum }} / {{ robotInfo.fireExtinguisherNum }}</div>
					</div>

					<div class="eventInfo-title" style="margin-top: 10px;" v-if="robotInfo.eType == 'E0300'">车辆信息：</div>
					<div style="textAlign: left;">
						<img :src="newRobotInfo.imgList[1].imgUrl" v-if="robotInfo.eType == 'E0300' && newRobotInfo.imgList.length > 1" style="width: 8vw;height: 3vw;" alt="">
					</div>

					<div class="eventInfo-table" v-if="robotInfo.eType == 'E0300'">
						<div class="table-div">车牌号</div>
						<div class="table-div" style="background-color: #001127;">{{ robotInfo.carId ? robotInfo.carId : '一' }}</div>
						<div class="table-div">车位编号</div>
						<div class="table-div" style="background-color: #001127;">{{ robotInfo.carNum ? robotInfo.carNum : '一' }}</div>
					</div>
				</div>

				<div style="margin: 1%;" v-if="robotInfo.remark">
					<div class="remoke-title">{{ languageJson.Notes }}：{{ robotInfo.remark }}</div>
				</div>

				<div v-if="type != 'admin'">
					<div v-if="robotInfo.results != '1' && robotInfo.results != '3' && robotInfo.results != '5'">
						<div style="margin: 1%;">
							<div class="remoke-title">{{ languageJson.Notes }}</div>
							<el-input type="textarea" @focus="ruleForm.remark = ''" :rows="3" :placeholder="languageJson.pleaseEnterContent" maxlength="200" show-word-limit v-model="ruleForm.remark"></el-input>
						</div>
						<div style="display: flex;width: 100%;align-items: center;justify-content: center;padding-bottom: 1vw;">
							<div class="btn1" @click='doHandle()'>{{ languageJson.DetermineProcessing }}</div>
							<div class="btn1 btn2" @click='handleReport()'>{{ languageJson.ProcessAndReport }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import marquee from '@/components/marquee.vue'
	import {
		getItem
	} from '@/utils/auth'
	import {
		handleEvent,
		handleEventReport
	} from '@/api/admin'
	export default {
		name: '',
		data() {
			return {
				show2: false,
				languageJson: languageJson,
				ruleForm: {
					remark: languageJson.Properlyhandled
				},
				ifZoom: false,
				zoomNo: 0,
				checkInfo: {},
				checkIndex: 0,
				url: "",
				newRobotInfo: {
					imgList: []
				}
			}
		},
		props: {
			robotInfo: Object,
			type: String,
			robotID: String
		},
		components: {
			marquee
		},
		mounted() {
		},
		methods: {
			toRobotLink() {
				let that = this
				if (!that.robotID) {
					that.$router.push({
						name: 'detail',
						query: {
							robotId: that.robotInfo.robotId,
							type: that.type
						}
					})
				} else {
					if (that.robotID != that.robotInfo.robotId) {
						location.href = location.href.split('?')[0] + `?robotId=${that.robotInfo.robotId}&type=${that.type}`
						location.reload()
					}
				}
			},
			changeWrong() {
				this.$emit('wrong',true)
			},
			doHandle() {
				let that = this
				if (!that.ruleForm.remark) {
					that.$notify({
						title: languageJson.PleaseProcessing,
						type: 'warning'
					})
					return false
				} else {
					handleEvent({
						eventId: that.robotInfo.eventId,
						userId: getItem('userInfo').staffId,
						tenantInfoId: getItem('tenantInfoId'),
						remark: that.ruleForm.remark
					}).then(res => {
						that.$notify({
							title: languageJson.successful,
							type: 'success'
						})
						that.ruleForm.remark = ""
						that.close()
					})
				}
			},
			handleReport() {
				let that = this
				if (!that.ruleForm.remark) {
					that.$notify({
						title: languageJson.PleaseProcessing,
						type: 'warning'
					})
					return false
				} else {
					handleEventReport({
						eventId: that.robotInfo.eventId,
						eName: that.robotInfo.eName,
						number: that.robotInfo.number,
						userId: getItem('userInfo').staffId,
						staffName: getItem('userInfo').sName,
						tenantInfoId: getItem('tenantInfoId'),
						remark: that.ruleForm.remark
					}).then(res => {
						that.$notify({
							title: languageJson.successful,
							type: 'success'
						})
						that.ruleForm.remark = ""
						that.close()
					})
				}
			},
			close() {
				this.$emit('closeEventImage', true)
			}
		},
		watch: {
			robotInfo: {
				deep: true,
				immediate: true,
				handler(newValue, oldValue) {
					let that = this
					if (newValue.eventId) {
						that.newRobotInfo = newValue
						that.checkIndex = 0
						that.ruleForm.remark = languageJson.Properlyhandled
						setTimeout(() => {
							if (newValue.imgList.length == 1) {
								that.checkInfo = newValue.imgList[0]
								if (Number(newValue.imgList[0].width) > 0) {
									that.ifZoom = true
									that.$nextTick(function() {
										that.zoomNo = (that.$refs.imgEventDom.clientWidth * 0.98) / Number(newValue.imgList[0].width)
										that.$refs.showRotListRef.style.width = newValue.imgList[0].width + 'px'
										that.$refs.showRotListRef.style.height = newValue.imgList[0].height + 'px'
									})
								} else {
									that.ifZoom = false
									that.$nextTick(function() {
										that.$refs.showRotListRef.style.width = '100%'
										that.$refs.showRotListRef.style.height = '100%'
									})
								}
							} else if (newValue.imgList.length > 1) {
								that.ifZoom = false
								that.checkInfo = newValue.imgList[0]
								for (var i = 0; i < newValue.imgList.length; i++) {
									if (Number(newValue.imgList[i].width) > 0) {
										that.$nextTick(function() {
											that.ifZoom = true
											that.zoomNo = (that.$refs.imgEventDom.clientWidth * 0.98) / Number(newValue.imgList[i].width * 2)
											that.$refs.showRotListRef.style.width = newValue.imgList[i].width + 'px'
											that.$refs.showRotListRef.style.height = newValue.imgList[i].height + 'px'
										})
										return;
									} else {
										that.$nextTick(function() {
											that.$refs.showRotListRef.style.width = '100%'
											that.$refs.showRotListRef.style.height = '100%'
										})
									}
								}
							}
						}, 200)
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@opacity: 0.7;
	@opBackgroundColor: #1A3048;

	.imgEventDom /deep/ .el-button--mini, .el-button--mini.is-round {
		padding: 2px 10px;
	}

	.imgEventDom /deep/.el-textarea__inner {
		color: #b0d8ff;
		background-color: rgba(0, 15, 50, 0.6);
		border: 1px solid rgba(0, 180, 255, 0.25);
	}

	.imgEventDom /deep/ .el-form-item {
		margin-bottom: 0px;
	}

	.imgEventDom /deep/.el-form-item__label {
		color: white;
		font-size: 0.7vw;
		line-height: 25px;
	}

	.imgEventDom /deep/ .el-textarea__inner {
		font-size: 0.7vw;
	}

	.remoke-title {
		text-align: left;
		margin: .2vw 0;
		color: #9CC3FF;
		font-size: .7vw;
	}

	.eventAuto {
		position: absolute;
		height: 90%;
		width: 79.5%;
		overflow-y: auto;
		overflow-x: hidden;
	}

	::-webkit-scrollbar-track {
		border-radius: 10px;
		background-color: rgba(0, 20, 60, 0.5);
	}

	/*定义滑块 内阴影+圆角*/
	::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 6px rgba(0, 180, 255, 0.2);
		background-color: rgba(0, 100, 180, 0.4);
		cursor: pointer;
	}

	.eventInfo {
		margin: 1vw 0 .4vw .4vw;
		color: #b0d8ff;
		font-size: .7vw;
		&-title {
			text-align: left;
			margin-bottom: .2vw;
		}
		&-table {
			width: 99%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-color: rgba(0, 40, 90, 0.5);
			border: 1px solid rgba(0, 180, 255, 0.25);
			border-right: none;
		}

		.tbody {
			background-color: transparent;
			border: 1px solid rgba(0, 180, 255, 0.25);
			border-top: none;
			border-right: none;
		}

		.table-div {
			padding: 0.3vw 0;
			border-right: 1px solid rgba(0, 180, 255, 0.25);
			text-align: center;
			width: 30%;
		}
	}

	.title-top {
		display: flex;
		color: #fff;
		font-size: 1vw;
		align-items: center;
		justify-content: flex-start;
		&-text {
			color: #e0f0ff;
			font-size: 0.8vw;
			font-weight: 600;
			text-shadow: 0 0 8px rgba(0, 240, 255, 0.4);
		}

		img {
			width: 0.7vw;
			margin-right: 0.3vw;
			filter: drop-shadow(0 0 4px rgba(0, 240, 255, 0.5));
		}
	}

	.openImages {
		position: absolute;
		right: 1%;
		top: 45%;
		cursor: pointer;
		z-index: 999;
	}

	.imagesList {
		position: absolute;
		top: 0;
		right: 1%;
		z-index: 99;
		height: 100%;
		background: rgba(0,0, 0, .5);
		width: 16%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;

		div {
			margin-bottom: 2vw;
		}
	}

	.img_li {
		width: 100%;
		height: 100%;
		// border-radius: 10px;
		cursor: pointer;
	}

	.check_li {
		// filter: contrast(20%);
	}

	.changeTap {
		width: 16%;
		height: 25vw;
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-direction: column;
	}

	.showRobotClass {
		margin: 0 auto;
		// height: 20vw;
		font-size: 0;
		position: relative;

		.showRotList {
			width: 50%;
			height: 50%;
			display: inline-block;
			position: relative;
			color: white;
			font-size: 12px;

			img {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}

			div {
				padding: 3px 20px;
				background-color: @opBackgroundColor;
				opacity: @opacity;
			}

			.errDiv {
				border: 2px solid #ffd400;
				position: absolute;
				background-color: transparent;
				padding: 0;
			}

			.title {
				position: absolute;
				top: 0;
				left: 0;
				border-radius: 0 0 10px 0;
			}

			.time {
				position: absolute;
				bottom: 0;
				left: 0;
				border-radius: 0 10px 0 0;
			}
		}

		.showRotListOne {
			width: 100%;
			height: 100%;
		}
	}

	.box {
		width: 100%;
		// width: 1100px;
		// position: fixed;
		// left: 50%;
		// top: 50%;
		// background: url(../../../../static/imgV2/index-left-top.png) no-repeat;
		// background-size: 100% 100%;

		.top_box {
			display: flex;
			justify-content: space-between;
			margin: 1vw;
			// padding-top: 0.1vw;
			color: #fff;
			font-size: 1vw;
			height: 1vw;
		}

		.cent_box {
			display: flex;
			justify-content: space-between;
			margin: 12px;
			width: 100%;

			.li1 {
				width: 73%;
				position: absolute;
				left: 2%;
			}

			.li1s {
				width: 100%;
				border: 1px solid #274b9b;
				height: 340px;
				border-radius: 8px;
				color: #fff;
			}

			.bot {
				width: 100%;
				height: 30px;
				display: flex;
				color: #fff;
				justify-content: space-around;
				margin-top: 18px;
			}

			.flex_all {
				display: flex;
				color: #fff;
				justify-content: flex-end;
				align-items: center;
				line-height: 34px;
				margin-top: 20px;
			}

			.li2 {
				width: 21%;
				height: calc(100% - 100px);
				position: absolute;
				right: 2%;

				.flexs {

					.ul_box {
						width: 100%;
						height: 100px;
						border: 1px solid #274b9b;
						border-radius: 12px;
						position: relative;
						margin-bottom: 12px;
					}

					.bf {
						border: 1px solid #00abff;
					}
				}
			}
		}
	}

	.baceName {
		width: 100%;
		display: flex;
		align-items: center;
		margin: 2% 1%;
		// justify-content: space-between;
		flex-wrap: wrap;
		font-size: 0.7vw;
		color: white;

		.divText {
			width: 17%;
			padding-left: 1vw;
			text-align: left;
		}
	}

	.btn1 {
		width: 10vw;
		padding: 0.4vw 0;
		margin-right: 16px;
		font-size: 0.7vw;
		font-weight: 700;
		text-align: center;
		cursor: pointer;
		color: #b0d8ff;
		background: linear-gradient(180deg, rgba(0, 60, 120, 0.6), rgba(0, 30, 80, 0.8));
		border: 1px solid rgba(0, 180, 255, 0.3);
		border-radius: 4px;
		transition: all 0.3s ease;

		&:hover {
			background: linear-gradient(180deg, rgba(0, 100, 200, 0.7), rgba(0, 50, 120, 0.9));
			border-color: rgba(0, 240, 255, 0.5);
			color: #e0f0ff;
			box-shadow: 0 0 12px rgba(0, 240, 255, 0.2);
		}
	}

	.btn2 {
		margin-right: 0;
	}

</style>



// WEBPACK FOOTER //
// src/page/robotDetail/components/eventImgOpen.vue